<template>
  <span>
    <div
      v-if="field.type !== 'group'"
      :style="{ marginTop: !field.parent ? '25px' : '' }"
    >
      <InputLabel :field="field" :valid="isValid" />

      <component
        :is="inputMapping"
        :field="field"
        :value="value"
        :valid="isValid"
        :disabled="disabled"
        :error-messages="!isValid ? error : undefined"
        @input="onInputChange"
      ></component>
    </div>

    <v-row v-else>
      <v-col
        cols="12"
        :style="{ marginTop: '11px' }"
        v-for="childField of field.fields"
        :key="childField.id"
        :md="childFieldColumns(childField)"
      >
        <InputField
          :field="{ ...childField, parent: field }"
          :value="value[childField.id]"
          :showError="showError"
          :disabled="disabled"
          :error="error[childField.id]"
          @input="value => onInputChange(value, childField)"
          @error="error => $emit('error', error, childField)"
        />
      </v-col>
    </v-row>
  </span>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";

import { getRuleValidators } from "@/utils";
import InputLabel from "@/components/fields/InputLabel.vue";
import TextField from "@/components/fields/TextField.vue";
import TextAreaField from "@/components/fields/TextArea.vue";
import ComboBoxField from "@/components/fields/ComboBox.vue";
import SelectField from "@/components/fields/Select.vue";
import DatePickerField from "@/components/fields/DatePicker.vue";

export default {
  name: "InputField",

  props: ["field", "value", "showError", "error", "disabled"],
  components: {
    InputLabel,
    TextField,
    TextAreaField,
    ComboBoxField,
    SelectField,
    DatePickerField
  },

  data: () => ({}),

  created() {
    this.validate(this.value);
  },

  computed: {
    isValid() {
      if (this.showError) {
        return !this.error;
      }

      return true;
    },

    ruleValidators() {
      let { rules, required } = this.field;

      rules = [...(rules || [])];

      if (required) {
        rules.push("required");
      }

      if (rules.length) {
        return getRuleValidators(rules);
      }

      return [];
    },

    inputMapping() {
      const { type } = this.field;

      switch (type) {
        case "text":
          return "TextField";

        case "textarea":
          return "TextAreaField";

        case "dropdown":
          return "ComboBoxField";

        case "datepicker":
          return "DatePickerField";

        case "select":
          return "SelectField";

        default:
          throw new Error(`Invalid input type ${type}`);
      }
    }
  },
  methods: {
    childFieldColumns(childField) {
      if (_.isNumber(childField.columns)) {
        return childField.columns;
      }

      return 12 / this.field.fields.length;
    },

    validate(value, childField) {
      if (this.field.type === "group") {
        return;
      }

      let error = false;

      for (const validator of this.ruleValidators) {
        const errorMessage = validator(value);

        if (errorMessage !== true) {
          // console.log(this.field, errorMessage);

          error = errorMessage;
          break;
        }
      }

      this.$emit("error", error, childField || this.field);
    },

    onInputChange(value, childField) {
      if (value !== this.value) {
        // console.log("input change", this.field);
        // this.validate(value, childField);

        this.$emit("input", value, childField || this.field);
      }
    }
  },
  watch: {
    value(value) {
      this.validate(value);
    }
  }
};
</script>
